import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import(
      './viewer/MemberLoginDialog' /* webpackChunkName: "MemberLoginDialog" */
    ),
    import(
      './viewer/MemberLoginDialog.controller' /* webpackChunkName: "MemberLoginDialog" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('MemberLoginDialog', UiTypes),
};

export default entry;
